<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>产品管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row :gutter="20">
          <el-col :span="6" v-for="(card,index) in dataList" :key="card.id">
            <div class="product-card" :class="'product-card'+(index+1)">
              <div class="product-card-title">{{ card.title }}</div>
              <div class="product-card-flex">
                <div class="product-card-item" :class="hasPerms(item.authorityFlag) ?  '' : 'no-permission-product'" v-for="item in card.menuList" :key="item.id" @click="handleToDetail(item)">
                  <div class="product-card-icon">
                    <i class="icon iconfont" :class="item.icon"></i>
                  </div>
                  <div>{{ item.title }}</div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">订单概览</span>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :span="6" v-for="(item, i) of processedList" v-bind:key="i">
              <todo :item="item" :index="i"></todo>
            </el-col>
          </el-row>
        </el-card>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-card style="margin-top: 15px">
              <el-row class="title_row">
                <el-col>
                  <span class="title_class">商品总览</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="6"
                  v-for="(item, i) of goodsList"
                  v-bind:key="i"
                >
                  <div class="processed-list-back">
                    <div class="dataStatistics-desc">{{ item.number }}</div>
                    <div class="dataStatistics-title">{{ item.title }}</div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card style="margin-top: 15px">
              <el-row class="title_row">
                <el-col>
                  <span class="title_class">用户总览</span>
                </el-col>
              </el-row>
              <el-row>
                <el-col
                  :span="6"
                  v-for="(item, i) of userList"
                  v-bind:key="i"
                >
                  <div class="processed-list-back">
                    <div class="dataStatistics-desc">{{ item.number }}</div>
                    <div class="dataStatistics-title">{{ item.title }}</div>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col>
              <span class="title_class">营销工具</span>
            </el-col>
          </el-row>
          <div class="tool-con">
            <div class="tool-item" v-for="(item,index) in toolList" :key="item.id">
              <div class="tool-item-icon" :class="'coloricon-reverse'+(index+1)"><i class="icon iconfont" :class="item.icon"></i></div>
              <div class="tool-item-title">{{ item.title }}</div>
            </div>
          </div>
        </el-card>
    </div>
</template>
<script>
import { historicalProductStatistics } from '@/http/api'
import { hasPermission } from '@/permission/index.js'
export default {
  data () {
    return {
      dataList: [
        {
          id: 1,
          title: '订单管理',
          menuList: [
            {
              id: 1,
              title: '全部订单',
              authorityFlag: this.$chnEngStatusCode.product_management,
              icon: 'icon-dingdandingdanmingxishouzhimingxi',
              path: '/product_Management/product_management'
            },
            {
              id: 2,
              title: '退费订单审批',
              authorityFlag: this.$chnEngStatusCode.product_management,
              icon: 'icon-tuikuanguanli',
              path: '/product_Management/product_return_management'
            }
          ]
        },
        {
          id: 4,
          title: '产品开通管理',
          menuList: [
            {
              id: 1,
              title: '字库、练习题开通',
              icon: 'icon-huihuajinglingicon-351',
              authorityFlag: this.$chnEngStatusCode.thesaurus_management,
              path: '/product_Management/thesaurus_management'
            },
            {
              id: 2,
              title: '产品开通',
              authorityFlag: this.$chnEngStatusCode.product_open,
              icon: 'icon-chanpin1',
              path: '/product_Management/product_open'
            }
          ]
        },
        {
          id: 3,
          title: '优惠券管理',
          menuList: [
            {
              id: 1,
              title: '优惠券',
              authorityFlag: this.$chnEngStatusCode.coupon,
              icon: 'icon-quan',
              path: '/raceManagement/individual_management/coupon'
            },
            {
              id: 3,
              // title: '兑换码管理',
              title: '参赛码管理',
              authorityFlag: this.$chnEngStatusCode.productcode_management,
              icon: 'icon-chanpinbianma',
              path: '/product_Management/productcode_management'
            }
            // {
            //  id: 2,
            //  title: '参赛码管理',
            //  authorityFlag: this.$chnEngStatusCode.semi_final_form_code,
            //  icon: 'icon-shuzi',
            //  path: '/raceManagement/individual_management/semi_final_form_code'
            // }
          ]
        },
        {
          id: 2,
          title: '课程管理',
          menuList: [
            {
              id: 1,
              title: '学校课程管理',
              authorityFlag: this.$chnEngStatusCode.course_schoolorder_management,
              icon: 'icon-house-full',
              path: '/product_Management/course_schoolorder_management'
            },
            {
              id: 2,
              title: '教师课程管理',
              authorityFlag: this.$chnEngStatusCode.course_teacherorder_management,
              icon: 'icon-jiaoshi',
              path: '/product_Management/course_teacherorder_management'
            }
          ]
        }
      ],
      toolList: [
        {
          id: 1,
          title: '优惠套餐',
          icon: 'icon-taocantuijian',
          path: ''
        },
        {
          id: 2,
          title: '满减',
          icon: 'icon-cuxiaoguanli',
          path: ''
        },
        {
          id: 3,
          title: '新客优惠券',
          icon: 'icon-quan',
          path: ''
        },
        {
          id: 4,
          title: '优惠券',
          icon: 'icon-youhuiquan',
          path: ''
        },
        {
          id: 5,
          title: 'N元任选',
          icon: 'icon-qiehuanmoshi',
          path: ''
        },
        {
          id: 6,
          title: '拼团购',
          icon: 'icon-tuangou',
          path: ''
        },
        {
          id: 7,
          title: '限时折扣',
          icon: 'icon-zhekou',
          path: ''
        },
        {
          id: 8,
          title: '秒杀管理',
          icon: 'icon-miaosha',
          path: ''
        },
        {
          id: 9,
          title: '新品推荐',
          icon: 'icon-xinpin1',
          path: ''
        }
      ],
      processedList: [
        {
          icon: 'icon-daifahuo',
          title: '待支付订单',
          key: 'prepaidOrder',
          path: '/product_Management/product_management',
          status: '1',
          authorityFlag: this.$chnEngStatusCode.product_management,
          number: 0,
          menuTag: 1
        },
        {
          icon: 'icon-fahuo2',
          title: '待发货订单',
          key: 'orderForDelivery',
          path: '/product_Management/product_management',
          status: '2',
          authorityFlag: this.$chnEngStatusCode.product_management,
          number: 0,
          menuTag: 2
        },

        {
          icon: 'icon-truck-completed_fill',
          title: '已发货订单',
          key: 'shippedOrder',
          path: '/product_Management/product_management',
          status: '3',
          authorityFlag: this.$chnEngStatusCode.product_management,
          number: 0,
          menuTag: 3
        },
        {
          icon: 'icon-tuihuo',
          title: '待处理退款申请',
          key: 'pendingRefundRequest',
          path: '/product_Management/product_return_management?tab=1',
          status: '5',
          authorityFlag: this.$chnEngStatusCode.product_management,
          number: 0,
          menuTag: 4
        },
        {
          icon: 'icon-daishouhuo',
          title: '退货寄回订单',
          key: 'returnOrderToBeConfirmed',
          path: '/product_Management/product_management',
          status: '11',
          authorityFlag: this.$chnEngStatusCode.product_management,
          number: 0,
          menuTag: 5
        },
        // {
        //   icon: 'icon-tuihuo',
        //   title: '待处理退款订单',
        //   key: 'pendingReturnOrder',
        //   path: '/product_Management/product_return_management?tab=1',
        //   status: '13',
        //   authorityFlag: this.$chnEngStatusCode.product_management,
        //   number: 0,
        //   menuTag: 6
        // },
        {
          icon: 'icon-yiwancheng',
          title: '已完成订单',
          key: 'completedOrder',
          path: '/product_Management/product_management',
          status: '4',
          authorityFlag: this.$chnEngStatusCode.product_management,
          number: 0,
          menuTag: 7
        },
        {
          icon: 'icon-dingdanguanbi',
          title: '已关闭订单',
          key: 'closeOrder',
          path: '/product_Management/product_management',
          status: '9',
          authorityFlag: this.$chnEngStatusCode.product_management,
          menuTag: 8,
          number: 0
        },
        {
          icon: 'icon-tuikuanguanli',
          title: '退款成功订单',
          key: 'refundOrder',
          path: '/product_Management/product_management',
          status: '8',
          authorityFlag: this.$chnEngStatusCode.product_management,
          menuTag: 6,
          number: 0
        }
        // {
        //   icon: 'icon-guanggaoguanli',
        //   title: '广告位即将到期',
        //   key: 'theAdSpaceIsAboutToExpire',
        //   number: 0
        // }
      ],
      goodsList: [
        {
          title: '在售商品',
          number: 0,
          key: 'activeListings'
        },
        {
          title: '下架商品',
          number: 0,
          key: 'removedListings'
        },
        {
          title: '全部商品',
          number: 0,
          key: 'allListings'
        }
      ],
      userList: [
        {
          title: '今日新增',
          number: 0,
          key: 'today'
        },
        {
          title: '昨日新增',
          number: 0,
          key: 'addedYesterday'
        },
        {
          title: '本月新增',
          number: 0,
          key: 'newThisMonth'
        },
        {
          title: '用户总数',
          number: 0,
          key: 'totalNumberOfUsers'
        }
      ]

    }
  },
  created () {
    this.getData()
  },
  methods: {
    handleToDetail ({ path, status, authorityFlag }) {
      if (!this.hasPerms(authorityFlag)) {
        return this.$message.warning('暂无操作权限')
      }
      if (path) {
        const query = status ? { status } : null
        this.$router.push({ path, query })
      }
    },
    hasPerms: function (flag) {
      // 根据权限标识和外部指示状态进行权限判断
      return hasPermission(flag) // & !this.disabled
    },
    getData () {
      historicalProductStatistics({ activityType: this.$chnEngStatusCode.activityType }).then(res => {
        Object.keys(res.data).forEach(key => {
          if (this.processedList.find(item => item.key === key)) {
            this.processedList.find(item => item.key === key).number = res.data[key]
          }
        })
      })

      // 用户总览
      this.$http.get('product/userStatistics', { params: { activityType: this.$chnEngStatusCode.activityType } }).then(res => {
        if (res.code === 200) {
          Object.keys(res.data).forEach(key => {
            if (this.userList.find(item => item.key === key)) {
              this.userList.find(item => item.key === key).number = res.data[key]
            }
          })
        }
      })

      // 商品总览
      this.$http.get('product/productStatistics', { params: { activityType: this.$chnEngStatusCode.activityType } }).then(res => {
        if (res.code === 200) {
          Object.keys(res.data).forEach(key => {
            if (this.goodsList.find(item => item.key === key)) {
              this.goodsList.find(item => item.key === key).number = res.data[key]
            }
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.product-card{
  height: 120px;
  color: #fff;
  border-radius: 6px;
  .product-card-title{
    height: 36px;
    line-height: 36px;
    padding-left: 20px;
    background-color: rgba(255,255,255,.25);
  }
  .product-card-flex{
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .product-card-item{
    flex: 1;
    text-align: center;
    height: 54px;
    margin-top: 15px;
    border-right: 1px solid rgba(255,255,255,.2);
    font-size: 14px;
    cursor: pointer;
    &:last-child{
      border-right: none;
    }
    .iconfont{
      font-size: 24px;
    }
  }
  .product-card-icon{
    margin-bottom: 4px;
  }
}
.product-card1{background-color: #4b89ff;}
.product-card2{background-color: #f96067;}
.product-card3{background-color: #3bc587;}
.product-card4{background-color: #fac02c;}

.tool-con{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .tool-item{
    text-align: center;
    flex: 1;
  }
  .tool-item-icon{
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 8px;
    .iconfont{
      font-size: 24px;
    }
  }
  .tool-item-title{
    color: #333;
    font-size: 14px;
  }
}

</style>
